// extracted by mini-css-extract-plugin
export default {"dot":"styles_dot__x8q1T","customLegend":"styles_customLegend__J-ekT","customLegendItem":"styles_customLegendItem__WP-dA"};